import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ReceiptIcon from '@mui/icons-material/Receipt';
import apiRequest from '../../../../../utils/apiRequest';
import { ORDERS_HISTORY } from '../../../../../apis';
import { handleChangeDataOrderDetails } from '../../../../../redux/actions/pages/user/orderDetails';
import CardOrder from './cards/cardOrder';
import OrderEmpty from '../../../../../styles/images/svg/order-empty.svg';
import CardOrderDetailsConsignment from './cards/cardOrderDetailsConsignment';



const OrderDetails = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { uniqueCode } = useParams();

	const { isMobile } = useSelector(state => state.general);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { token } = useSelector(state => state.login);
	const { content } = useSelector(state => state.orderDetails);

	

	useEffect(() => {
        apiOrderDetails();
    }, [OrderDetails]);



	const apiOrderDetails = () => {
		if(! isBackdropLoading) {
			apiRequest({
			    dispatch,
			    endpoint: ORDERS_HISTORY + '/' + uniqueCode,
			    method: 'get',
			    token: token, 
			    onSuccess: (res) => {
			      	dispatch(handleChangeDataOrderDetails('content', res.content));
			    },
		  	});
		}
	};

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

    return (
    	
    	<div className="lg:bg-neutral-000 lg:rounded-medium overflow-hidden lg:border-complete-200">
			<div className="border-complete-b-200 mb-2 lg:mb-0">
				<div className="bg-neutral-000 flex items-center border-complete-b-200 px-3 py-4 lg:px-6 mb-2 lg:mb-0">
					<div className="cursor-pointer" onClick={() => navigate(-1)}>
						<div className="flex">
							<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
								<use xlinkHref="#arrowRight" />
							</svg>
						</div>
					</div>
					<div className="grow text-h5 text-neutral-900 mr-2">جزئیات سفارش
					</div>
					{/*<a className="flex items-center gap-1 text-button-2 text-secondary-500 cursor-pointer" data-cro-id="profile-see-factor" target="_blank" href="/profile/orders/invoice/order/31184966/">
						<div className="flex">
							<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}}>
								<use xlinkHref="#invoice" />
							</svg>
						</div>مشاهده فاکتور
					</a>*/}
				</div>
				<div className="bg-neutral-000 px-5 py-4 lg:px-6">
					<div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 gap-y-2 pb-4 border-complete-b">
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">کد پیگیری سفارش
							</div>
							<div className="text-body1-strong text-neutral-800">{toPersianDigits(uniqueCode)}
							</div>
						</div>
						<div className="flex hidden lg:flex">
							<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
								<use xlinkHref="#dotOutline" />
							</svg>
						</div>
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">تاریخ ثبت سفارش
							</div>
							<div className="text-body1-strong text-neutral-800">{toPersianDigits(content.registerDate ?? '')}
							</div>
						</div>
					</div>
					<div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 gap-y-2 pt-4 pb-2">
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">تحویل گیرنده
							</div>
							<div className="text-body1-strong text-neutral-800">{content.userName ?? ''}
							</div>
						</div>
						<div className="flex hidden lg:flex">
							<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
								<use xlinkHref="#dotOutline" />
							</svg>
						</div>
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">شماره موبایل
							</div>
							<div className="text-body1-strong text-neutral-800">{toPersianDigits(content.mobile ?? '')}
							</div>
						</div>
					</div>
					<div className="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-2">
						<div className="flex items-center justify-between lg:justify-start gap-1 grow flex-col lg:flex-row items-start">
							<div className="text-body-1 text-neutral-500 ml-1 self-start whitespace-nowrap">آدرس
							</div>
							<div className="text-body1-strong text-neutral-800 text-body1-strong self-start">{content.address ?? ''}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="px-5 lg:px-3 py-4 lg:px-6 bg-neutral-000 border-complete-b-200 lg:border-none lg:border-complete-b-200 mb-2 lg:mb-0">
				<div className="flex flex-col lg:flex-row items-stretch !lg:items-center gap-3 gap-y-2 lg:flex-wrap">
					<div className="flex items-center justify-between lg:justify-start gap-1">
						<div className="text-body-1 text-neutral-500 ml-1">مبلغ
						</div>
						<div className="text-body1-strong text-neutral-800">
							<div className="flex justify-start items-center">
								<div className="ml-1 text-neutral-800">{toPersianDigits(content.productPrice ?? '')}
								</div>
								<div className="w-4 h-4">
									<div className="flex">
										<svg style={{width: '16px', height: '16px', fill: 'var(--undefined)'}}>
											<use xlinkHref="#toman" />
										</svg>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="flex hidden lg:flex">
						<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
							<use xlinkHref="#dotOutline" />
						</svg>
					</div>
					<div className="flex items-center justify-between lg:justify-start gap-1">
						<div className="text-body-1 text-neutral-500 ml-1">سود شما از خرید
						</div>
						<div className="text-body1-strong text-neutral-800">
							<div className="flex justify-start items-center">
								<div className="ml-1 text-neutral-800">{toPersianDigits(content.totalDiscount ?? '')}
								</div>
								<div className="w-4 h-4">
									<div className="flex">
										<svg style={{width: '16px', height: '16px', fill: 'var(--undefined)'}}>
											<use xlinkHref="#toman" />
										</svg>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="flex hidden lg:flex">
						<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
							<use xlinkHref="#dotOutline" />
						</svg>
					</div>
					<div className="flex items-center justify-between lg:justify-start gap-1">
						<div className="text-body-1 text-neutral-500 ml-1">
							<div className="lg:hidden text-body1-strong">نوع پرداخت
							</div>
						</div>
						<div className="text-body1-strong text-neutral-800">
							<span className="text-neutral-800 lg:text-neutral-600 font-bold">پرداخت آنلاین
							</span>
						</div>
					</div>
					<div className="flex flex-col lg:flex-row w-full grow items-stretch lg:items-center gap-3 gap-y-2 border-complete-t-200 !lg:border-none pt-3 lg:pt-0 OrderDetailsSummary_OrderDetailsSummary__transactionHeaderDetailsBox__l28v6">
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">هزینه ارسال  
							</div>
							<div className="text-body1-strong text-neutral-800">
								<div className="flex justify-start items-center">
									<div className="ml-1 text-neutral-800">{toPersianDigits(content.shippingPrice ?? '')}
									</div>
									<div className="w-4 h-4">
										<div className="flex">
											<svg style={{width: '16px', height: '16px', fill: 'var(--undefined)'}}>
												<use xlinkHref="#toman" />
											</svg>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="grow" />
					{/*<div className="flex items-center gap-1 text-button-2 text-secondary-500 cursor-pointer mx-auto lg:mx-0 mb-4 lg:mb-0 OrderDetailsSummary_OrderDetailsSummary__transactionHeaderLink__1tXBM">تاریخچه تراکنش‌ها
						<div className="OrderDetailsSummary_OrderDetailsSummary__transactionIconMotion__WtTX3">
							<div className="flex">
								<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}}>
									<use xlinkHref="#expandMore" />
								</svg>
							</div>
						</div>
					</div>*/}
				</div>
			</div>

			{
				content.consignments?.map((consignment, key) => (
					<CardOrderDetailsConsignment key={`order-details-consignment-${key}`} data={consignment} num={key + 1} size={content.consignments.length} />
				))
			}
		</div>

    );
}

export default OrderDetails;